import type { SvgIconComponent } from "@mui/icons-material";
import { Box } from "@mui/material";
import { SidebarLink } from "@tngtech/tng-ui";
import React from "react";
import { InfoToolTip } from "./InfoTooltip.tsx";

export const UnavailableSidebarLink = ({
  title,
  icon,
  reason,
  reasonId,
  tooltipIcon,
  label,
}: {
  title: string;
  icon: React.ComponentType;
  reason: string;
  reasonId: string;
  tooltipIcon?: SvgIconComponent;
  label?: string;
}) => (
  <Box
    sx={{
      "& .MuiLink-root": { color: "text.disabled", cursor: "default" },
      "& > div:hover": { backgroundColor: "transparent" },
    }}
  >
    <SidebarLink
      title={
        <>
          {title}
          {}
          {}
          <Box
            component="span"
            sx={{
              display: "block",
              color: "text.primary",
              "& .MuiSvgIcon-root": { ml: 0 },
            }}
          >
            <InfoToolTip
              helpertext={reason}
              ariaDescribedById={reasonId}
              icon={tooltipIcon}
            />
            {label && (
              <Box
                component="span"
                sx={{ ml: 0.5, fontSize: "0.75rem", verticalAlign: "middle" }}
              >
                {label}
              </Box>
            )}
          </Box>
        </>
      }
      icon={icon}
    />
  </Box>
);
